var map = {
	"./fortuneIcon.svg": 665,
	"./fortuneIconL.svg": 666,
	"./helpdeskIcon.svg": 667,
	"./helpdeskIconL.svg": 668,
	"./homeIcon.svg": 669,
	"./homeIconLarge.svg": 670,
	"./jackpotIcon.svg": 671,
	"./logo.svg": 672,
	"./logoSmall.svg": 673,
	"./loyaltyIcon.svg": 674,
	"./mobileAppIcon.svg": 675,
	"./profileIcon.svg": 676,
	"./questIcon.svg": 677,
	"./rewardLineupIcon.svg": 678,
	"./searchIcon.svg": 679,
	"./searchIconLarge.svg": 680,
	"./signOutIcon.svg": 681,
	"./star.svg": 682,
	"./tournamentIcon.svg": 683,
	"./tournamentLargeIcon.svg": 684,
	"./vipIcon.svg": 685,
	"./wheelIcon.svg": 686,
	"./wheelIconL.svg": 687,
	"./wheelIconMobile.svg": 688
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 664;